// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"EzloNotificationTemplate_icon-container__qU-rr","infoContent":"EzloNotificationTemplate_infoContent__2il9M"};